import React from 'react';
import { Checkbox } from 'freemium-ui';
import { SurveyQuestionType, SurveyType } from 'freemium-survey-components';
import { ConsentCheckbox } from './styles';

type ConsentProps = {
  question: SurveyQuestionType;
  resolvedQuestionAnswer: string;
  surveyInfo: SurveyType;
  brandColor: string;
  labels?: string[];
};

const Consent = (props: ConsentProps) => {
  const { question, resolvedQuestionAnswer, brandColor, labels } = props;

  return (
    <p className="description">
      {question?.type_info?.meta?.display_format === 'BUTTON' &&
      resolvedQuestionAnswer !== '-' ? (
        String(resolvedQuestionAnswer) === 'true' ? (
          String(labels?.[0])
        ) : String(resolvedQuestionAnswer) === 'false' ? (
          String(labels?.[1])
        ) : (
          '-'
        )
      ) : (
        <>
          {String(resolvedQuestionAnswer) === 'true' ||
          String(resolvedQuestionAnswer) === 'false' ? (
            <ConsentCheckbox
              brandColor={
                String(resolvedQuestionAnswer) === 'true'
                  ? brandColor
                  : 'transparent'
              }
              borderColor={brandColor}
            >
              <Checkbox
                checked={
                  String(resolvedQuestionAnswer) === 'true' ? true : false
                }
              />
              {String(labels?.[2])}
            </ConsentCheckbox>
          ) : (
            '-'
          )}
        </>
      )}
    </p>
  );
};

export default Consent;
